import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {usePlayerValidators} from './usePlayerValidators'
import {MechanicValidatorCityImprovements} from '@colonist/game-mechanic-validators'
import {useMapValidator} from './useMapValidator'

export const useMechanicValidatorCityImprovements = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const mechanicCityImprovementsState = useGameStore((state) => state.gameState.mechanicCityImprovementsState)

    return useMemo(() => {
        if(!mechanicCityImprovementsState) return undefined
        return new MechanicValidatorCityImprovements(playerValidators, mapValidator, mechanicCityImprovementsState)
    }, [mapValidator, playerValidators, mechanicCityImprovementsState])
}
